import React from 'react';

import { useTranslation } from '@lt/localization';
import { TEXT } from '../../constants';
import { Title } from '../../styles';
import EntryRules from '../EntryRules';

import type { TitleProps } from '../../types';
import styles from './titleLoading.module.css';

type TitleLoadingProps = Pick<
  TitleProps,
  'destinationText' | 'type' | 'isMobile' | 'className' | 'departureCity'
>;

export const TitleLoading = (props: TitleLoadingProps) => {
  const { destinationText, type, isMobile, className, departureCity } = props;

  const { toursType } = TEXT[type];

  const { t } = useTranslation();

  const titleText = departureCity
    ? `${t('search.title.loading', {
        toursType,
      })} ${destinationText} ${departureCity}...`
    : `${t('search.title.loading', {
        toursType,
      })} ${destinationText}...`;

  return (
    <Title className={className} $isMobile={isMobile}>
      <span className={styles.titleText}>{titleText}</span>
      <EntryRules />
    </Title>
  );
};
